export type ConfirmationDialogProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  title: string;
};

export { default as ConfirmationDialog } from './ConfirmationDialog';
